import request from '@/utils/request'

export function wxJsConfig(data) {
  return request.post('/wx-js', data)
}

export function getCurrentDate(data) {
  return request.post('/closing-date/curr-date', data)
}



// WEBPACK FOOTER //
// ./src/api/commons.js